<div class="mainBG">

    <div class="white container-fluid mainContent">
        <div class="lock-screen">
            <div class="animate fadeIn text-center">
                <!-- added 'row' class -->
                <div class="row">
                    <div class="col-md-7 px-0">
                        <!-- replaced 'img-responsive' class with 'img-fluid' -->
                        <img src="assets/images/Left_Img.png" height="550px" class="img-fluid" style="height: 550px;">
                    </div>

                    <div class="col-md-5 p-0 bottom-align1 bg-white roundedRight">
                        <div class="col-md-12">
                            <!-- added 'row' class -->
                            <div class="row mb-10 justify-content-lg-center">
                                <!-- *ngIf="loginservice && loginservice.hideGebbsLogo==false" -->

                                <span class="col-md-6">
                                    <div class="mt-5">
                                        <img src="assets/images/iAR.png" width="98px" height="66px">
                                    </div>
                                </span>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="col-md-12 p-0">
                                <div class="heading-panel sT-hight p-0">
                                    <span class="text-ellipsis heading-txt blue-text h-height"
                                        style="top: 40px; position: absolute;  left: 68px;">Sign In</span>
                                </div>
                            </div>
                        </div>
                        <form [formGroup]="MyForm" (ngSubmit)="getIP()" novalidate
                            style="top: 5vh;position: relative;left: 5vh;">
                            <div class="col-md-12">

                                <div class="form-item">
                                    <input type="text" required type="text" maxlength="20" formControlName="username"
                                        name="username" id="username"
                                        [ngClass]="{'input-error': MyForm.get('username').hasError('required') && DisplayError}">
                                    <label for="username">Username</label>
                                    <span class="fa fa-exclamation-circle errspan"
                                        *ngIf="MyForm.get('username').hasError('required') && DisplayError"
                                        title="Username is required"></span>
                                </div>
                            </div>
                            <div class="col-md-12">

                                <div class="form-item password-wrapper">
                                    <input [type]="showPassword ? 'text' : 'password'" required type="password" maxlength="20"
                                        formControlName="password" name="password" id="password"
                                        [ngClass]="{'input-error': MyForm.get('password').hasError('required') && DisplayError}"
                                        appCapsLock (capsLockStatus)="capsLockOn=$event"
                                        >
                                      <label for="password">Password</label>
                                      
                                        <!-- Eye Icon -->
                                         <i *ngIf="MyForm.get('password').value.length >= 1 && !isProduction"
                                             class="pi password-eye"
                                             [ngClass]="showPassword ? 'pi-eye-slash' : 'pi-eye'"
                                             (click)="togglePassword()">
                                         </i>
                                         <small class="caps-warning" *ngIf="capsLockOn">
                                            ⚠ Caps Lock is ON
                                        </small>
                                         
                                    <span class="fa fa-exclamation-circle errspan"
                                        *ngIf="MyForm.get('password').hasError('required') && DisplayError"
                                        title="Password is required"></span>
                                </div>
                                <a class="forgotP" (click)="redirectForgot('/forgot-password')"> Forgot Password ?</a>
                            </div>
                            <div class="col-md-10" *ngIf="MyForm.controls.captchaData as captcha" style="padding: 5px;">
                                <div class="form-group" style="margin-bottom:0">
                                    <div class="captchaContainer">
                                        <img [src]="showCaptcha" alt="captcha" class="captcha">

                                        <div class="controls" style="margin-left: 5px;">
                                            <div class="" style="width: 155px; margin-right: -10px;">
                                                <input class="form-control valid" formControlName="captchaData"
                                                    type="text" placeholder="Type above text"
                                                    [ngClass]="{'input-error': MyForm.get('captchaData').hasError('required') && DisplayError}">
                                            </div>
                                            <button title="Refresh Captcha Code" type="button" class="btn btn-primary"
                                                style="height: 28px; padding-top: 3px;" (click)="callCaptcha()">
                                                <i [ngClass]="{'rotate': isCaptcha == true}" class="fa fa-refresh"></i>
                                            </button>
                                            <span class="errorSection" *ngIf="captcha.touched==true || DisplayError"
                                                style="position: absolute;left: 15vh;top: 29vh;">
                                                <!-- <span class="error"
                                                    *ngIf="MyForm.get('captchaData').hasError('required') && DisplayError">
                                                    Captcha is required.
                                                </span> -->
                                                <div class="error"
                                                    *ngIf="captcha.errors && captcha.errors.invalidCaptcha">
                                                    Please type valid Captcha
                                                </div>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- added col-md-12 -->
                            <div class="col-md-12">
                                <!-- added 'row' class -->
                                <div class="row text-start" style="left: 12vh; position: relative; top: 2vh;">

                                    <div class="col-md-6" style="    float: left;top: 5px; left: 10px;">
                                        <button *ngIf="!isLoaded" id="disclaimerModal" data-toggle="modal"
                                            [disabled]="DisableSubmit"
                                            class="btn btn-default blue square-btn blue-hover btn-txt"
                                            style="width: 90%;">Sign in</button>
                                        <button *ngIf="isLoaded"
                                            class="btn btn-default blue square-btn blue-hover btn-txt" type="button"
                                            disabled style="width: 90%;">
                                            <span class="spinner-border spinner-border-sm" role="status"
                                                aria-hidden="true" style="display: inline-block;margin: 0 5px;"></span>
                                            Loading...
                                        </button>
                                    </div>
                                    <!-- <div class="col-md-6" style="float: right">
                                        <button type="submit" [disabled]="DisableSubmit" (click)="redirectForgot('/forgot-password')" class="btn btn-default blue square-btn blue-hover btn-txt w-100">Forgot
                                            password ?</button>
                                    </div> -->
                                </div>
                            </div>

                        </form>

                        <div *ngIf="!loginservice.isHideGebbsLogo" class="release-footer col-12 text-center mt-5"
                            style="position: relative;top:10%; left:50%;">

                            <span>Released Version: {{ReleasedVersion}}</span><br>

                            <span>
                                Copyright &copy; {{CurrentYear}} GeBBS Healthcare Solutions |
                                <span>
                                    <a class="text-primary focus" style="cursor:pointer" (click)="ShowCopyright()">
                                        Disclaimer
                                    </a>
                                </span>
                            </span>

                        </div>

                    </div>
                </div>

                <div class="row justify-content-center text-white py-2" style="font-size: 10px;">
                    <p><b>Security Notice:</b> You are using a secure web connection. Your password will be encrypted in
                        transit to our web server, but will remain on your
                        browser until you exit it.
                    </p>
                </div>

            </div>
        </div>


    </div>
</div>



<div class="modal fade bd-example-modal-lg" id="myModal" role="dialog"
    [ngClass]="[isShow == true ? 'showmodal' : 'hidemodal']">
    <div class="modal-dialog" style="max-width: 750px!important;">
        <app-disclaimer (closeModal)="closeModal()" (onAcceptDiscalimer)="onAcceptDiscalimer()"></app-disclaimer>
    </div>
</div>
<div class="modal fade bd-example-modal-lg" id="myModal" role="dialog"
    [ngClass]="[showCopyright == true ? 'showmodal' : 'hidemodal']">
    <div class="modal-dialog" style="max-width: 750px!important;">
        <div class="modal-content modalContent" style="margin-top: 20rem;">
            <div class=" modalHeader" style="text-align: center;">
                <button type="button" class="close closebtn"data-dismiss="modal"
                    (click)="closeCopyright()">&times;</button>
                <h4 style="font-size: 19px;
                font-weight: 700;" class="modal-title"><i class="fa fa-warning"></i> UNAUTHORIZED ACCESS TO THIS
                    SERVICE IS PROHIBITED.</h4>
            </div>
            <div class="modal-body">


                <div class="disclaimer-text" style="font-size: 11px; line-height: 16px; text-align: justify;">
                    <p class="para" style="text-align: center;">
                        <span style="font-weight: 700;">PLEASE READ THE TERMS AND CONDITIONS :</span>
                        <br> <br>
                        <span style="text-align: center;">iAR is confidential and proprietary, and is for authorized
                            users only. All authorized users are subject to contractual use restrictions and
                            nondisclosure requirements that prevent giving access to third parties. Unauthorized users
                            are subject to prosecution, lawsuits, and penalties under state and federal law. All system
                            activities are monitored, recorded and reviewed by system personnel. Anyone using this
                            system expressly consents to such monitoring and is hereby warned that if such monitoring
                            reveals possible evidence of criminal activity by the user, the same shall be reported to
                            law enforcement Agency. Provider reserves the right, at its sole discretion, to change,
                            modify the software or program at any time without notice. Any rights not expressly granted
                            herein are reserved.
                        </span><br> <br> <br>
                        <span style="font-weight: 700;">Contact: Infosec Team - infosec&#64;gebbs.com</span>

                    </p>
                </div>
            </div>
            <div class="modal-footer" style="display: inline;">
                <button type="button" class="btn btn-default blue square-btn blue-hover btn-txt "
                    (click)="closeCopyright()" style="margin-left:45%;font-size: 1.3rem;"
                    data-dismiss="modal">Close</button>
            </div>
        </div>

    </div>
</div>